import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import styles from './MainBannerWarpper.module.scss';

import { ProForm } from '../ProForm';

interface Props {
  proJobType?: string;
}

const MainBannerWrapper: FC<Props> = ({ proJobType = '' }) => {
  const { t } = useTranslation();

  return (
    <section className={styles['main-banner-container']} data-test-id="main-banner-container">
      <div className={styles['background-img']}>
        <div className={styles['pro-ad-background']}></div>
        <div className={styles['pro-ad']}></div>
      </div>
      <div className={styles['banner-pc']}>
        {/* @ts-expect-error ProForm is not yet typed */}
        <ProForm t={t} proJobType={proJobType} isMobileDevice={false} />
      </div>
      <div className={classNames(styles['banner-mobile'], styles['pro-form-mobile'])}>
        {/* @ts-expect-error ProForm is not yet typed */}
        <ProForm t={t} proJobType={proJobType} isMobileDevice={true} />
      </div>
    </section>
  );
};

export default MainBannerWrapper;
